export default {
  primary: '#eaaa64',
  secondary: '#404041'
}
